// @flow
import React from "react";
import PageContainer from "../containers/PageContainer";
import NearbyConsultants from "../containers/NearbyConsultants";
import { useTranslation } from 'react-i18next';
import { useDidCache, useDidRecover } from 'react-router-cache-route'

export default function NearbyConsultantsView() {
    const { t } = useTranslation();
    useDidCache(() => {
        console.log('List cached 1')
    })

    // support multiple effect
    useDidCache(() => {
        console.log('List cached 2')
    })

    useDidRecover(() => {
        console.log('List recovered')
    })
    return (
        <PageContainer title={t("Nearby Consultants")} showShopToolbar={true}>
            <div className="near-by-consultant-container container">
                <div className="row">

                    <div className="col">

                        <NearbyConsultants />

                    </div>
                </div>
            </div>

        </PageContainer>
    );
}
